import { AibleClientFactory } from "client/aible/factory";
import { DEFAULT_ERROR_MESSAGE } from "containers/ChatGPT/reducer";
import { toast } from "react-toastify";
import { delay } from "utils/promise";
export function getResponseDataContent(data) {
    if (data === undefined) {
        return "";
    }
    else if ("output" in data) {
        return data.output?.content;
    }
    return "";
}
export function getResponseContent(response) {
    return getResponseDataContent(response?.data);
}
export async function getDetectValuesBackend(accountId, datasetId, prompt) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    const result = await factory.getCompletionClient().getDetectedValues(datasetId, prompt);
    return result;
}
export async function getContentValidationResult(accountId, id) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    const result = await factory.getCompletionClient().awaitContentValidationResult(id);
    return result;
}
export async function waitForExecutionCompletion(id) {
    return await AibleClientFactory.getInstance()
        .getContentGenerationClient()
        .getExecutionById(id)
        .then(async (execution) => {
        if (execution.status === "SUCCEEDED" || execution.status === "ERROR" || execution.status === "FAILED") {
            return execution;
        }
        return delay(1000).then(async () => await waitForExecutionCompletion(id));
    });
}
export async function doComplete(accountId, request, options, handleStreamingCallback) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    const completion = await factory.getCompletionClient().createCompletion(request, options);
    console.log("doComplete what is request and options", request, options);
    if (completion.status == "ERROR") {
        const errorMessage = completion.message ?? DEFAULT_ERROR_MESSAGE;
        const errorDetails = {
            id: completion.id
        };
        if (completion.error && completion.error.type) {
            const errorCause = completion.error.type;
            errorDetails.type = errorCause;
            throw Error(errorMessage, { cause: errorDetails });
        }
        else {
            throw Error(errorMessage, { cause: errorDetails });
        }
    }
    return completion;
}
export async function getFinishedCompletion(accountId, id) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    return await factory.getCompletionClient().getFinishedCompletion(id);
}
export async function savePreferredRequest(accountId, executionId, preferredExecutionId) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    const saveRequestResponse = await factory
        .getCompletionClient()
        .savePreferredRequest(executionId, preferredExecutionId);
    return saveRequestResponse;
}
export async function getPreferredRequests(accountId, request, options) {
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
    return factory.getCompletionClient().getPreferredRequests(request, options);
}
export async function getErrorNotebook(accountId, chatId) {
    try {
        const accountClient = AibleClientFactory.getInstance().getAccountClient();
        const account = await accountClient.getAccount(accountId);
        const factory = await accountClient.getCustomerClientFactory(accountId);
        const notebookResponse = await factory.getCompletionClient().getErrorNotebookUrl(chatId);
        if (notebookResponse.type === "notebook-error") {
            throw new Error(notebookResponse.message);
        }
        Object.values(notebookResponse.notebooks).forEach(async (notebook) => {
            const res = await accountClient.presignedGetRequest(account, notebook.url, notebook.name);
            await res.downloadFile();
        });
    }
    catch (e) {
        let errorMessage = "There was issue fetching the notebook:";
        const retError = e;
        if (retError?.message) {
            errorMessage = retError.message;
        }
        toast(errorMessage, {
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 7500
        });
        throw e;
    }
}
